import React, {useContext, useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import NavPanel from "../components/NavPanel";
import '../styles/SelectedCompany.css';
import {Context} from "../index";
import {observer} from "mobx-react-lite";
import {
    companyDeleteAPI,
    companyGetAPI,
    companyRepresentativeAddAPI,
    companyRepresentativeDeleteAPI, companyRepresentativeUpdateAPI,
    companySetBookmarkAPI,
    companyUpdateAPI
} from "../http/companyAPI";
import {usersGetApi} from "../http/userApi";
import {payeesGetApi} from "../http/payeeAPI";
import {groupsGetApi, groupAddCompanyApi, groupRemoveCompanyApi} from "../http/groupAPI";
import {URLS} from "../utils/urls";
import {getUserHighestRole} from "../utils/userRoles";
import {WsTriggers} from "../WebsocketTriggers";
import CalculationTable, {
    CalculationDataType,
    CalculationResultType,
    gatherTableData,
    CalcConfig,
    DEFAULT_CALC_CONFIG,
    normalizeCalcConfig,
    configOfCalcTable
} from "../components/CalculationTable";
import HistoryContainer from "../components/HistoryContainer";
import {calculationPostAPI} from "../http/calculationAPI";
import CalculationsContainer from "../components/CalculationsContainer";
import TtnContainer from "../components/TtnContainer";
import Popup from "../components/Popup";

const saveIco = require('../assets/icons/selectedComp/saveIco.png');
const saveUnactiveIco = require('../assets/icons/selectedComp/saveUnactiveIco.png');
const editIco = require('../assets/icons/selectedComp/editIco.png');
const editUnactiveIco = require('../assets/icons/selectedComp/editUnactiveIco.png');
const delIco = require('../assets/icons/selectedComp/deleteIco.png');
const backIco = require('../assets/icons/selectedComp/backIco.png');



type RprType = {
    id: number,
    position: string | null,
    fullName: string | null,
    phone: string | null,
    email: string | null,
    companyId: number
};
type NewRprType ={
    position?: string | null | undefined;
    fullName?: string | null | undefined;
    phone?: string | null | undefined;
    email?: string | null | undefined;
    companyId?: number | undefined; }

type CompanyType = {
    id: number;
    name: string;
    code: string | null;
    country: string | null;
    city: string | null;
    region: string | null;
    address: string | null;
    curatorId: number | null;
    curatorName?: string;
    payeeId: number | null;
    payee?: { id: number, name: string } | null;
    bookmarkedByUserId?: number | null;
    bookmarkedBy?: BookmarkUserType | null;
    groups?: Array<CompanyGroupType>;
    representative: Array<RprType>;
};
type CompanyGroupType = { id: number, name: string, color: string | null, ownerId: number | null };
type GroupLiteType = {
    id: number,
    name: string,
    color: string | null,
    ownerId: number | null,
    owner: { id: number, username: string } | null,
};
const DEFAULT_GROUP_COLOR = '#4f8ef7';
type UserType = {
    id: number;
    username: string;
}
type BookmarkUserType = {
    id: number;
    username: string;
    bookmarkColor: string | null;
    bookmarkLabel: string | null;
};

// Shown wherever a bookmarked user has no colour of their own yet.
const DEFAULT_BOOKMARK_COLOR = '#f5a623';
type PayeeOption = { id: number, name: string };


const CompanyContentView = (props: {
    compData: CompanyType,
    isEditable: boolean,
    userIdToName: { [key: number]: string },
    payees: Array<PayeeOption>,

}): JSX.Element => {
    const isEd = props.isEditable;
    const compData = props.compData;
    const userIdToName = props.userIdToName;
    const payees = props.payees;


    return (
        <table className='selectedComp__table'>
            <tbody className='selectedComp__tbody'>
            <tr className='selectedComp__tr'>
                <td className='selectedComp__td selectedComp__td-dynamic'>
                    {
                        !isEd ?
                            <span>{ compData.name }</span>
                            :
                            <input className='selectedComp__input' name='name' required={true} type="text"
                                   maxLength={128} minLength={3} autoComplete='off' defaultValue={ compData.name }/>
                    }
                </td>
                <td className='selectedComp__td selectedComp__td-static'>Наименование</td>
            </tr>
            <tr className='selectedComp__tr'>
                <td className='selectedComp__td selectedComp__td-dynamic'>
                    {
                        !isEd ?
                            <span>{ compData.code }</span>
                            :
                            <input className='selectedComp__input' name='code' type="text" maxLength={10}
                                   autoComplete='off' defaultValue={ compData.code ? compData.code : '' }/>
                    }
                </td>
                <td className='selectedComp__td selectedComp__td-static'>Код ЄДРПОУ</td>
            </tr>
            <tr className='selectedComp__tr'>
                <td className='selectedComp__td selectedComp__td-dynamic'>
                    {
                        !isEd ?
                            <span>{ compData.country }</span>
                            :
                            <input className='selectedComp__input' name='country' type="text" maxLength={128}
                                   autoComplete='off' defaultValue={ compData.country ? compData.country : '' }/>
                    }
                </td>
                <td className='selectedComp__td selectedComp__td-static'>Страна</td>
            </tr>
            <tr className='selectedComp__tr'>
                <td className='selectedComp__td selectedComp__td-dynamic'>
                    {
                        !isEd ?
                            <span>{ compData.city }</span>
                            :
                            <input className='selectedComp__input' name='city' type="text" maxLength={128}
                                   autoComplete='off' defaultValue={ compData.city ? compData.city : '' }/>
                    }
                </td>
                <td className='selectedComp__td selectedComp__td-static'>Город</td>
            </tr>
            <tr className='selectedComp__tr'>
                <td className='selectedComp__td selectedComp__td-dynamic'>
                    {
                        !isEd ?
                            <span>{ compData.region }</span>
                            :
                            <input className='selectedComp__input' name='region' type="text" maxLength={128}
                                   autoComplete='off' defaultValue={ compData.region ? compData.region : '' }/>
                    }
                </td>
                <td className='selectedComp__td selectedComp__td-static'>Область</td>
            </tr>
            <tr className='selectedComp__tr'>
                <td className='selectedComp__td selectedComp__td-dynamic'>
                    {
                        !isEd ?
                            <span>{ compData.address }</span>
                            :
                        <input className='selectedComp__input' name='address' type="text" maxLength={128}
                               autoComplete='off' defaultValue={ compData.address ? compData.address : '' }/>
                    }
                </td>
                <td className='selectedComp__td selectedComp__td-static'>Адрес</td>
            </tr>
            <tr className='selectedComp__tr'>
                <td className='selectedComp__td selectedComp__td-dynamic'>
                    {
                        !isEd ?
                            <span>{ compData.curatorName ? compData.curatorName: '' }</span>
                            :
                            <select className='selectedComp__select' name="curator" defaultValue={
                                compData.curatorId ? compData.curatorId : 'null'
                            }>
                                <option className='selectedComp__option' value="null">Не назначен</option>
                                {
                                    Object.entries(userIdToName).map((u) =>
                                            <option key={`user${u[0]}`} className='selectedComp__option'
                                                    value={`${u[0]}`}>{u[1]}</option>
                                    )
                                }
                            </select>
                    }
                </td>
                <td className='selectedComp__td selectedComp__td-static'>Куратор</td>
            </tr>
            <tr className='selectedComp__tr'>
                <td className='selectedComp__td selectedComp__td-dynamic'>
                    {
                        !isEd ?
                            <span>{ compData.payee ? compData.payee.name : '—' }</span>
                            :
                            <select className='selectedComp__select' name="payee" defaultValue={
                                compData.payeeId ? compData.payeeId : 'null'
                            }>
                                <option className='selectedComp__option' value="null">По умолчанию</option>
                                {
                                    payees.map((p) =>
                                        <option key={`payee${p.id}`} className='selectedComp__option'
                                                value={`${p.id}`}>{p.name}</option>
                                    )
                                }
                            </select>
                    }
                </td>
                <td className='selectedComp__td selectedComp__td-static'>Получатель оплаты</td>
            </tr>
            </tbody>
        </table>
    )
}


const RepresentativeContentView = (props: {
    compData: CompanyType,
    permissions: Set<string>,
    editableRprData: RprType | null,
    setEditableRprData: React.Dispatch<React.SetStateAction<RprType | null>>,
    newRprData: NewRprType | null,
    setNewRprData: React.Dispatch<React.SetStateAction<NewRprType | null>>,
    isSaveBtnActive: boolean,
    editableRpr: number | null;
    setEditableRpr: React.Dispatch<React.SetStateAction<number | null>>,
    editingRprData: RprType | null,
    setEditingRprData: React.Dispatch<React.SetStateAction<RprType | null>>,
}) => {
    const rprData: Array<RprType> = props.compData.representative;
    const perms: Set<string> = props.permissions;

    const hasRprAdd = perms.has('representative.add');
    const hasRprUpdate = perms.has('representative.update');


    const inputNewCompData = (e: React.ChangeEvent<HTMLInputElement>) => {

        const {name, value} = e.target;
        props.setNewRprData({
            ...props.newRprData,
            [name]: value
        })
    };

    const inputEditCompData = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (props.editingRprData === null) {
            const form = e.target.form;
            if (form) {
                const {editingFullName, editingPosition, editingPhone, editingEmail} = form;
                const newData = {
                    editingFullName: editingFullName.value,
                    editingPosition: editingPosition.value,
                    editingPhone: editingPhone.value,
                    editingEmail: editingEmail.value,
                }
                // @ts-ignore
                props.setEditingRprData(newData);

            }
        } else {
            const {name, value} = e.target;
            props.setEditingRprData({
                ...props.editingRprData,
                [name]: value
            })
        }
    }


    const AddNewRprBtn = () => {

        return (
            props.isSaveBtnActive ?
                <td className='selectedComp__rpr-td selectedComp__rpr-new-td'>
                    <button className='selectedComp__icon-button'
                            onClick={(e) => {
                                e.preventDefault();
                                const compId = `${window.location.pathname}`.split('/').pop();
                                const newData = props.newRprData;
                                if (newData && typeof compId === 'string') {
                                    newData['companyId'] = parseInt(compId);
                                    companyRepresentativeAddAPI(newData)
                                        .then((response) => {
                                            if (response.status === 200) {

                                            } else {
                                                alert('Some error')
                                            }
                                        })
                                        .catch((err) => {
                                            console.log(err)
                                        })
                                }
                            }}>
                        <img src={saveIco} alt="save" className='selectedComp__icon'/>
                    </button>
                </td>
                :
                <td className='selectedComp__rpr-td selectedComp__rpr-new-td'>
                    <div className='selectedComp__save-button-cover'></div>
                    <button className='selectedComp__icon-button'>
                        <img src={saveUnactiveIco} alt="save" className='selectedComp__icon'/>
                    </button>
                </td>

        )
    }

    const EditRprBtn = (params: { id: number }) => {

        return (
            hasRprUpdate ?
                props.editableRpr === null ?
                    <td className='selectedComp__rpr-td selectedComp__rpr-new-td'>
                        <button className='selectedComp__icon-button'
                            onClick={(e) => {
                                e.preventDefault();
                                props.setEditableRpr(params.id);
                            }}>
                            <img src={editIco} alt="edit" className='selectedComp__icon'/>
                        </button>
                    </td>
                    :
                    props.editableRpr === params.id ?
                        <td className='selectedComp__rpr-td selectedComp__rpr-new-td'>
                            <div className='selectedComp__rpr-edit-tools-container'>
                                <button className='selectedComp__rpr-edit-tools-btn'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (!props.editingRprData) {
                                            props.setEditableRpr(null);
                                            return
                                        }
                                        // @ts-ignore
                                        const { editingFullName, editingPosition, editingPhone, editingEmail } = props.editingRprData;
                                        const newEditingData = {
                                            fullName: editingFullName.length > 0 ? editingFullName: null,
                                            position: editingPosition.length > 0 ? editingPosition: null,
                                            phone: editingPhone.length > 0 ? editingPhone: null,
                                            email: editingEmail.length > 0 ? editingEmail: null,
                                            id: params.id,
                                            companyId: `${window.location.pathname}`.split('/').pop()
                                        }

                                        companyRepresentativeUpdateAPI(newEditingData.id, newEditingData)
                                            .then((response) => {
                                                if (response.status === 200) {
                                                    props.setEditableRpr(null);
                                                    return
                                                } else {
                                                    alert('Some error')
                                                }
                                            })
                                            .catch((err) => {
                                                console.log(err)
                                            })

                                    }}>
                                    <img src={saveIco} alt="save" className='selectedComp__rpr-edit-tools-btnIco'/>
                                </button>
                                <button className='selectedComp__rpr-edit-tools-btn'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        props.setEditableRpr(null);
                                    }}>
                                    <img src={backIco} alt="back" className='selectedComp__rpr-edit-tools-btnIco'/>
                                </button>
                                <button className='selectedComp__rpr-edit-tools-btn'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        companyRepresentativeDeleteAPI(params.id)
                                            .then((response) => {
                                                if (response.status === 200) {
                                                    props.setEditableRpr(null);
                                                } else {
                                                    alert('Some error')
                                                }
                                            })
                                            .catch((err) => {
                                                console.log(err)
                                            })
                                    }}>
                                    <img src={delIco} alt="del" className='selectedComp__rpr-edit-tools-btnIco'/>
                                </button>
                            </div>
                        </td>
                        :
                        <td className='selectedComp__rpr-td selectedComp__rpr-new-td'>
                            <div className='selectedComp__save-button-cover'></div>
                            <button className='selectedComp__icon-button'>
                                <img src={editUnactiveIco} alt="edit" className='selectedComp__icon'/>
                            </button>
                        </td>
                : null
        )
    }

    return (
        <table className='selectedComp__rpr-table'>
            <tbody className='selectedComp__rpr-tbody'>
            <tr className='selectedComp__rpr-tr'>
                <td className='selectedComp__rpr-td selectedComp__rpr-td-static'>ФИО</td>
                <td className='selectedComp__rpr-td selectedComp__rpr-td-static'>Должность</td>
                    <td className='selectedComp__rpr-td selectedComp__rpr-td-static'>Телефон</td>
                    <td className='selectedComp__rpr-td selectedComp__rpr-td-static'>Почта</td>
                    {hasRprUpdate || hasRprAdd ? <td className='selectedComp__rpr-td selectedComp__rpr-td-static'></td> : null}
                </tr>
                {
                    rprData.map((rpr: RprType) =>
                        props.editableRpr === null ?
                            <tr key={`rpr-${rpr.id}`}
                                className='selectedComp__rpr-tr'>
                                <td className='selectedComp__rpr-td'>{rpr.fullName}</td>
                                <td className='selectedComp__rpr-td'>{rpr.position}</td>
                                <td className='selectedComp__rpr-td'>{rpr.phone}</td>
                                <td className='selectedComp__rpr-td'>{rpr.email}</td>
                                {
                                    hasRprUpdate ?
                                        <EditRprBtn id={rpr.id}/>
                                        :
                                        null
                                }
                            </tr>
                            :
                            props.editableRpr === rpr.id ?
                                <tr key={`rpr-${rpr.id}`}
                                    className='selectedComp__rpr-tr'>
                                    <td className='selectedComp__rpr-td'>
                                        <input
                                            id='editingFullName'
                                            className='selectedComp__rpr-input' name='editingFullName' type="text" required={true}
                                               autoComplete='off' maxLength={128} placeholder='Фамилия Имя Отчество'
                                               defaultValue={rpr.fullName ? rpr.fullName : ''}
                                               onChange={(e) => inputEditCompData(e)}/>
                                    </td>
                                    <td className='selectedComp__rpr-td'>
                                        <input
                                            id='editingPosition'
                                            className='selectedComp__rpr-input' name='editingPosition' type="text"
                                                autoComplete='off' maxLength={128} placeholder='Должность'
                                               defaultValue={rpr.position ? rpr.position : ''}
                                               onChange={(e) => inputEditCompData(e)}/>
                                    </td>
                                    <td className='selectedComp__rpr-td'>
                                        <input
                                            id='editingPhone'
                                            className='selectedComp__rpr-input' name='editingPhone' type="text" autoComplete='off'
                                               maxLength={128} placeholder='+380000000000'
                                               defaultValue={rpr.phone ? rpr.phone : ''}
                                               onChange={(e) => inputEditCompData(e)}/>
                                    </td>
                                    <td className='selectedComp__rpr-td'>
                                        <input
                                            id='editingEmail'
                                            className='selectedComp__rpr-input' name='editingEmail' type="text" autoComplete='off'
                                                maxLength={128} placeholder='email@gmail.com'
                                               defaultValue={rpr.email ? rpr.email : ''}
                                               onChange={(e) => inputEditCompData(e)}/>
                                    </td>

                                    {
                                        hasRprUpdate ?
                                            <EditRprBtn id={rpr.id}/>
                                            :
                                            null
                                    }
                                </tr>
                                :
                                <tr key={`rpr-${rpr.id}`}
                                    className='selectedComp__rpr-tr'>
                                    <td className='selectedComp__rpr-td'>{rpr.fullName}</td>
                                    <td className='selectedComp__rpr-td'>{rpr.position}</td>
                                    <td className='selectedComp__rpr-td'>{rpr.phone}</td>
                                    <td className='selectedComp__rpr-td'>{rpr.email}</td>
                                    {
                                        hasRprUpdate ?
                                            <EditRprBtn id={rpr.id}/>
                                            :
                                            null
                                    }
                                </tr>
                    )
                }
            {
                hasRprAdd ?
                    <tr className='selectedComp__rpr-tr'>
                        <td className='selectedComp__rpr-td'>
                            <input className='selectedComp__rpr-input' name='fullName' type="text" required={true}
                                   autoComplete='off' maxLength={128} placeholder='Фамилия Имя Отчество'
                                   onChange={(e) => inputNewCompData(e)}/>
                        </td>
                        <td className='selectedComp__rpr-td'>
                            <input className='selectedComp__rpr-input' name='position' type="text"
                                   autoComplete='off' maxLength={128} placeholder='Должность'
                                       onChange={(e) => inputNewCompData(e)}/>
                            </td>
                            <td className='selectedComp__rpr-td'>
                                <input className='selectedComp__rpr-input' name='phone' type="text" autoComplete='off'
                                        maxLength={128} placeholder='+380000000000'
                                       onChange={(e) => inputNewCompData(e)}/>
                            </td>
                            <td className='selectedComp__rpr-td'>
                                <input className='selectedComp__rpr-input' name='email' type="text" autoComplete='off'
                                        maxLength={128} placeholder='email@gmail.com'
                                       onChange={(e) => inputNewCompData(e)}/>
                            </td>
                            <AddNewRprBtn/>
                        </tr>
                        :
                        null
                }


            </tbody>
        </table>
    )
}


const SelectedCompany = observer(() => {
    const {user, ws} = useContext(Context);

    useEffect(() => {
        const message: string | null = ws.getMsg;
        if (message !== null) {
            const compId = `${window.location.pathname}`.split('/').pop();
            if (message === WsTriggers.SELECTED_COMPANY + `+${compId}`) {
                requestCompanyData();

                ws.setMessage(null);
            } else if (message === WsTriggers.GROUPS) {
                requestGroups();
                requestCompanyData();
                ws.setMessage(null);
            }

        }
    }, [ws.getMsg]);


    const [perms, setPerms] = useState<Set<string>>(new Set());

    const [userIdToName, setUserIdToName] = useState<{ [key: number]: string }>({});
    const [payees, setPayees] = useState<Array<PayeeOption>>([]);
    const [payeeConfigs, setPayeeConfigs] = useState<{ [id: number]: CalcConfig }>({});
    const [defaultPayeeConfig, setDefaultPayeeConfig] = useState<CalcConfig>(DEFAULT_CALC_CONFIG);
    // No built-in fallback anymore: a payee only gets a "new calculation" table
    // once an admin has actually created a CalcTable for it (currentCalcTableId).
    const [payeeHasTable, setPayeeHasTable] = useState<{ [id: number]: boolean }>({});
    const [defaultPayeeHasTable, setDefaultPayeeHasTable] = useState<boolean>(false);
    const [compData, setCompData] = useState<CompanyType | null>(null);

    const [isCompDataEdit, setIsCompDataEdit] = useState<boolean>(false);
    const [isCompDataDelete, setIsCompDataDelete] = useState<boolean>(false);

    const [editableRprData, setEditableRprData] = useState<RprType | null>(null);
    const [newRprData, setNewRprData] = useState<NewRprType | null>(null);
    const [editingRprData, setEditingRprData] = useState<RprType | null>(null);

    const [isSaveBtnActive, setIsSaveBtnActive] = useState<boolean>(false);
    const [editableRpr, setEditableRpr] = useState<number | null>(null);

    const [isPopupActive, setIsPopupActive] = useState<boolean>(false);
    const [headerNamePopup, setHeaderNamePopup] = useState<string>('');
    const [bodyDivElementPopup, setBodyDivElementPopup] = useState<JSX.Element>(<></>);

    const [isSaveLoader, setIsSaveLoader] = useState(false);

    useEffect(() => {
        setPerms(user.getPermissions.data_);
    }, [user.getPermissions]);

    useEffect(() => {
        let isLen = false;

        if (newRprData === null) {
            setIsSaveBtnActive(false)
        } else {
            Object.entries(newRprData).forEach((el: any) => {
                if (el[1].length > 0) {
                    isLen = true
                }
            })
            if (isLen) {
                setIsSaveBtnActive(true);
            } else {
                setIsSaveBtnActive(false);
            }
        }
    }, [newRprData]);


    const requestCompanyData = (params?: { usersMap: { [key: number]: string } }) => {
        const compId = window.location.pathname.split('/').pop();
        const usersMap: { [key: number]: string } = params && params.usersMap ? params.usersMap : userIdToName;

        if (compId) {
            companyGetAPI({companyId: compId})
                .then((response) => {
                    if (response.data) {
                        const newCompanyData: CompanyType = response.data;
                        newCompanyData.curatorName = newCompanyData.curatorId ? usersMap[newCompanyData.curatorId] : '';
                        setCompData(newCompanyData);
                    } else {
                        window.location.replace(URLS.COMPANIES_URL);
                    }
                })
                .catch((err) => { console.log(err) })
        }
    }

    // ── "Закладка" ────────────────────────────────────────────────────────
    // One bookmark per company; whose it is decides its colour/label (set in
    // the owner's profile). No edit mode. A regular user toggles only their
    // own; an admin picks any user (or "нет") from a dropdown. The WS
    // SELECTED_COMPANY trigger refetches to reconcile.
    const [isBookmarkBusy, setIsBookmarkBusy] = useState<boolean>(false);
    const [bookmarkUsers, setBookmarkUsers] = useState<Array<BookmarkUserType>>([]);
    const isAdmin = getUserHighestRole() === 'admin';
    // Бухгалтер: the whole company card is read-only except ТТН — no
    // toggling a bookmark of their own either.
    const isAccountant = getUserHighestRole() === 'accountant';
    const currentUserId = Number(user.getUser.id);

    const bm = compData?.bookmarkedBy ?? null;
    const bmColor = bm ? (bm.bookmarkColor || DEFAULT_BOOKMARK_COLOR) : null;
    const bmByMe = compData?.bookmarkedByUserId != null && compData.bookmarkedByUserId === currentUserId;
    const bmLockedForMe = !isAdmin && compData?.bookmarkedByUserId != null && !bmByMe;

    const applyBookmarkResponse = (response: any) => {
        if (response?.data && 'bookmarkedByUserId' in response.data) {
            setCompData((prev) => prev ? {
                ...prev,
                bookmarkedByUserId: response.data.bookmarkedByUserId ?? null,
                bookmarkedBy: response.data.bookmarkedBy ?? null,
            } : prev);
        }
    };

    const runBookmarkChange = (userId?: number | null) => {
        if (!compData || isBookmarkBusy) return;
        setIsBookmarkBusy(true);
        companySetBookmarkAPI(compData.id, userId)
            .then(applyBookmarkResponse)
            .catch((err) => { console.log(err); })
            .finally(() => { setIsBookmarkBusy(false); });
    };

    const handleToggleBookmark = () => {
        if (bmLockedForMe) return;
        runBookmarkChange();
    };
    const handleAdminBookmarkChange = (value: string) => {
        runBookmarkChange(value === '' ? null : Number(value));
    };

    // ── Группы ───────────────────────────────────────────────────────────
    // Show the groups this company is in; a user can add/remove it from any
    // group they own (or any group, if admin). Membership changes broadcast
    // GROUPS + SELECTED_COMPANY, so both this list and compData refetch.
    const [allGroups, setAllGroups] = useState<Array<GroupLiteType>>([]);
    const [groupBusy, setGroupBusy] = useState<boolean>(false);

    const requestGroups = () => {
        groupsGetApi()
            .then((res) => { if (Array.isArray(res?.data)) setAllGroups(res.data); })
            .catch((err) => { console.log(err); });
    };
    useEffect(() => { requestGroups(); }, []);

    const canManageGroup = (g: { ownerId: number | null }): boolean =>
        isAdmin || (g.ownerId != null && g.ownerId === currentUserId);

    const changeGroupMembership = (groupId: number, mode: 'add' | 'remove') => {
        if (!compData || groupBusy) return;
        setGroupBusy(true);
        const call = mode === 'add'
            ? groupAddCompanyApi(groupId, compData.id)
            : groupRemoveCompanyApi(groupId, compData.id);
        call
            .then(() => { requestCompanyData(); requestGroups(); })
            .catch((err) => { console.log(err); })
            .finally(() => setGroupBusy(false));
    };

    const companyGroups = compData?.groups ?? [];
    const addableGroups = allGroups.filter(
        (g) => canManageGroup(g) && !companyGroups.some((cg) => cg.id === g.id)
    );


    useEffect(() => {
        payeesGetApi().then((res) => {
            if (Array.isArray(res?.data)) {
                setPayees(res.data.map((p: any) => ({ id: p.id, name: p.name })));

                // A payee's current CalcTable (immutable once used) is the source of
                // truth going forward; `calcConfig` only still matters for payees that
                // predate CalcTable and never got one.
                const configOf = (p: any) => configOfCalcTable(p.currentCalcTable) ?? p.calcConfig;

                const configs: { [id: number]: CalcConfig } = {};
                const hasTables: { [id: number]: boolean } = {};
                res.data.forEach((p: any) => {
                    configs[p.id] = normalizeCalcConfig(configOf(p));
                    hasTables[p.id] = p.currentCalcTableId != null;
                });
                setPayeeConfigs(configs);
                setPayeeHasTable(hasTables);

                const def = res.data.find((p: any) => p.isDefault);
                if (def) {
                    setDefaultPayeeConfig(normalizeCalcConfig(configOf(def)));
                    setDefaultPayeeHasTable(def.currentCalcTableId != null);
                }
            }
        });
    }, []);

    useEffect(() => {
        usersGetApi()
            .then((response) => {
                if (response.data) {
                    const newUsersMap: { [key: number]: string } = {};
                    response.data.forEach((el: UserType) => { newUsersMap[el.id] = el.username });
                    requestCompanyData({ usersMap: newUsersMap });

                    // Full list (with per-user bookmark look) for the admin
                    // "чья закладка" picker — keep everyone, superuser included.
                    setBookmarkUsers(response.data.map((el: any) => ({
                        id: el.id,
                        username: el.username,
                        bookmarkColor: el.bookmarkColor ?? null,
                        bookmarkLabel: el.bookmarkLabel ?? null,
                    })));

                    if (user.getUser.username !== 'superuser') {
                        delete newUsersMap[1]
                    }

                    setUserIdToName(newUsersMap);
                }
            })
            .catch((err) => { console.log(err) })
    }, []);


    const handleSaveButton = () => {
        const companyId = window.location.pathname.split('/').pop();

        const resultData: {
            tableData: CalculationDataType,
            tableResult: CalculationResultType,
        } = gatherTableData({ Key: 'baseCalc' })


        if (Object.entries(resultData.tableData).length !== 0) {
            setIsSaveLoader(true);
            calculationPostAPI(resultData, companyId, user.getUser.id)
                .then((response) => {
                    setIsSaveLoader(false);
                })
                .catch((err) => {
                    console.log(err)
                })
        }
        return
    }

    // Tax rates for the "new calculation" table: this company's bound payee, or
    // the default payee when it isn't tied to one.
    const calcTableConfig: CalcConfig =
        (compData?.payeeId != null && payeeConfigs[compData.payeeId])
            ? payeeConfigs[compData.payeeId]
            : defaultPayeeConfig;

    // No calc table shown at all until the resolved payee actually has one —
    // no falling back to the built-in default schema.
    const hasCalcTable = compData?.payeeId != null
        ? !!payeeHasTable[compData.payeeId]
        : defaultPayeeHasTable;

    return (
        <div className='selectedComp page-content-container'>
            <Popup
                isActive={isPopupActive}
                setIsActive={setIsPopupActive}
                headerName={headerNamePopup}
                bodyDivElement={ bodyDivElementPopup }
            ></Popup>
            <NavPanel/>
            <div className='selectedComp_body page_content_body'>
                <div className='selectedComp_company-data-container'>
                    <div className="selectedComp__comp-container contentWindow">
                        <div className="selectedComp__data-header contentWindow__header selectedComp__data-header--with-bookmark">
                            <span className="contentWindow__name">Данные о предприятии</span>
                            {
                                isAdmin ?
                                    <div className='selectedComp__bookmark-picker'>
                                        {
                                            bm ?
                                                <span className='selectedComp__bookmark-btn is-active'
                                                      style={{
                                                          borderColor: bmColor as string,
                                                          backgroundColor: `${bmColor}22`,
                                                          color: bmColor as string,
                                                      }}
                                                      title={`Закладка: ${bm.bookmarkLabel || bm.username}`}>
                                                    <span className='selectedComp__bookmark-icon' aria-hidden='true'
                                                          style={{ color: bmColor as string }}>★</span>
                                                    {bm.bookmarkLabel || bm.username}
                                                </span>
                                                :
                                                <span className='selectedComp__bookmark-btn'>
                                                    <span className='selectedComp__bookmark-icon' aria-hidden='true'>☆</span>
                                                    Без закладки
                                                </span>
                                        }
                                        <select className='select selectedComp__bookmark-select'
                                                value={compData?.bookmarkedByUserId != null ? `${compData.bookmarkedByUserId}` : ''}
                                                disabled={!compData || isBookmarkBusy}
                                                onChange={(e) => handleAdminBookmarkChange(e.target.value)}
                                                title='Чья закладка на предприятии'>
                                            <option value=''>Без закладки</option>
                                            {bookmarkUsers.map((u) => (
                                                <option key={`bmUser-${u.id}`} value={`${u.id}`}>
                                                    {u.bookmarkLabel ? `${u.username} — ${u.bookmarkLabel}` : u.username}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    :
                                    isAccountant ?
                                    (
                                        bm &&
                                        <span className='selectedComp__bookmark-btn is-active'
                                              style={{
                                                  borderColor: bmColor as string,
                                                  backgroundColor: `${bmColor}22`,
                                                  color: bmColor as string,
                                              }}
                                              title={`Закладка: ${bm.bookmarkLabel || bm.username}`}>
                                            <span className='selectedComp__bookmark-icon' aria-hidden='true'
                                                  style={{ color: bmColor as string }}>★</span>
                                            {bm.bookmarkLabel || bm.username}
                                        </span>
                                    )
                                    :
                                    <button type='button'
                                            className={'selectedComp__bookmark-btn' + (bm ? ' is-active' : '')}
                                            style={bm ? {
                                                borderColor: bmColor as string,
                                                backgroundColor: `${bmColor}22`,
                                                color: bmColor as string,
                                            } : undefined}
                                            disabled={!compData || isBookmarkBusy || bmLockedForMe}
                                            onClick={handleToggleBookmark}
                                            title={
                                                !bm ? 'Добавить в закладки'
                                                : bmByMe ? 'Убрать из закладок'
                                                : `Закладка: ${bm.bookmarkLabel || bm.username}`
                                            }
                                            aria-pressed={!!bm}>
                                        <span className='selectedComp__bookmark-icon' aria-hidden='true'
                                              style={bm ? { color: bmColor as string } : undefined}>
                                            {bm ? '★' : '☆'}
                                        </span>
                                        {!bm ? 'В закладки' : bmByMe ? 'В закладках' : (bm.bookmarkLabel || bm.username)}
                                    </button>
                            }
                        </div>
                        <nav className="selectedComp__data-nav contentWindow__nav">
                            {
                                user.getPermissions.has('company.update') ?
                                    !isCompDataEdit ?
                                        <button className='nav__button btn-ghost selectedComp__navBtn selectedComp__navBtn-edit'
                                                onClick={() => {
                                                    setIsCompDataEdit(true)
                                                }}
                                        >Редактировать</button>
                                        :
                                        <div>
                                            <button className='nav__button btn-primary selectedComp__navBtn selectedComp__save-btn'
                                                    form='compForm' type='submit'
                                            >Сохранить
                                            </button>
                                            <button
                                                className='nav__button btn-ghost selectedComp__navBtn selectedComp__cancel-btn'
                                                onClick={() => {
                                                    setIsCompDataEdit(false)
                                                }}
                                            >Отмена
                                            </button>
                                        </div>
                                    :
                                    null
                            }
                            {
                                user.getPermissions.has('company.delete') ?
                                    !isCompDataDelete ?
                                        <button className='nav__button btn-danger selectedComp__navBtn selectedComp__navBtn-delete'
                                                onClick={() => {
                                                    setIsCompDataDelete(true)
                                                }}
                                        >Удалить предприятие</button>
                                        :
                                        <div>
                                            <button
                                                className='nav__button btn-danger selectedComp__navBtn selectedComp__delete-btn'
                                                onClick={() => {
                                                    if (compData) {
                                                        companyDeleteAPI(compData.id)
                                                            .then((response) => {
                                                                if (response && response.status === 200) {
                                                                    window.location.replace(URLS.COMPANIES_URL);
                                                                }
                                                            })
                                                            .catch((err) => {
                                                                console.log(err)
                                                            })
                                                    }
                                                }}
                                            >Удалить
                                            </button>
                                            <button
                                                className='nav__button btn-ghost selectedComp__navBtn selectedComp__cancel-btn'
                                                onClick={() => {
                                                    setIsCompDataDelete(false)
                                                }}
                                            >Отмена
                                            </button>
                                        </div>
                                    :
                                    null
                            }
                        </nav>
                        <div className="selectedComp__data-body">
                            <form id='compForm' onSubmit={(e: any) => {
                                e.preventDefault();
                                const {name, code, country, city, region, address, curator, payee} = e.target;
                                if (compData) {
                                    const newCompanyData = {
                                        id: compData.id,
                                        name: name.value.replaceAll(' ', '').length === 0 ? '---' : name.value,
                                        code: code.value.length === 0 ? null : code.value,
                                        country: country.value.length === 0 ? null : country.value,
                                        city: city.value.length === 0 ? null : city.value,
                                        region: region.value.length === 0 ? null : region.value,
                                        address: address.value.length === 0 ? null : address.value,
                                        curatorId: curator.value === 'null' ? null : parseInt(curator.value),
                                        payeeId: (!payee || payee.value === 'null') ? null : parseInt(payee.value),
                                    };

                                    companyUpdateAPI({id: compData.id, data: newCompanyData})
                                        .then((response) => {
                                            if (response.status === 200) {
                                                setIsCompDataEdit(false);
                                            } else {
                                                alert('Some error occurred');
                                                console.log(response);
                                            }
                                        })
                                        .catch((err) => {
                                            alert('Some error occurred')
                                            console.log(err)
                                        })
                                }
                            }}>
                                {
                                    compData ? CompanyContentView({
                                        compData: compData,
                                        isEditable: isCompDataEdit,
                                        userIdToName: userIdToName,
                                        payees: payees
                                    }) : null
                                }
                            </form>
                        </div>

                        <div className="selectedComp__groups">
                            <span className="selectedComp__groups-label">Группы:</span>
                            <div className="selectedComp__groups-chips">
                                {
                                    companyGroups.length === 0 &&
                                    <span className="selectedComp__groups-empty">не состоит ни в одной</span>
                                }
                                {
                                    companyGroups.map((g) => {
                                        const color = g.color || DEFAULT_GROUP_COLOR;
                                        return (
                                            <span key={`compGroup-${g.id}`} className="selectedComp__group-chip"
                                                  style={{ borderColor: color, backgroundColor: `${color}22`, color }}>
                                                <Link className="selectedComp__group-chip-link"
                                                      style={{ color }}
                                                      to={URLS.COMPANY_GROUPS_URL}>{g.name}</Link>
                                                {
                                                    canManageGroup(g) &&
                                                    <button type="button" className="selectedComp__group-chip-x"
                                                            title="Убрать из группы" disabled={groupBusy}
                                                            onClick={() => changeGroupMembership(g.id, 'remove')}>×</button>
                                                }
                                            </span>
                                        );
                                    })
                                }
                                {
                                    addableGroups.length > 0 &&
                                    <select className="select selectedComp__groups-add"
                                            value=""
                                            disabled={groupBusy}
                                            onChange={(e) => { if (e.target.value) changeGroupMembership(Number(e.target.value), 'add'); }}>
                                        <option value="">+ в группу…</option>
                                        {addableGroups.map((g) => (
                                            <option key={`addGroup-${g.id}`} value={`${g.id}`}>{g.name}</option>
                                        ))}
                                    </select>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="selectedComp__rpr-container contentWindow">
                        <div className="selectedComp__data-header contentWindow__header">
                            <span className="contentWindow__name">Контакты</span>
                        </div>
                        <nav className="selectedComp__data-nav contentWindow__nav"></nav>
                        <div className="selectedComp__data-body">
                            <form id='rprForm'>
                                {
                                    compData ? RepresentativeContentView({
                                        compData: compData,
                                        permissions: user.getPermissions,
                                        editableRprData: editableRprData,
                                        setEditableRprData: setEditableRprData,
                                        newRprData: newRprData,
                                        setNewRprData: setNewRprData,
                                        isSaveBtnActive: isSaveBtnActive,
                                        editableRpr: editableRpr,
                                        setEditableRpr: setEditableRpr,
                                        editingRprData: editingRprData,
                                        setEditingRprData: setEditingRprData,
                                    }) : null
                                }
                            </form>
                        </div>
                    </div>
                </div>
                <div className="selectedComp_calculation-cotainer">
                    <div className="selectedComp__calc-container contentWindow">
                        <div className="selectedComp__data-header contentWindow__header">
                            <span className="contentWindow__name">Расчёт</span>
                        </div>
                        {hasCalcTable ? (
                            <>
                                <CalculationTable
                                    isEditable={true}
                                    Key='baseCalc'
                                    calcConfig={calcTableConfig}
                                />
                                <div className="selectedComp__calc-data-body selectedComp__calc-result-container" style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between'
                                }}>
                                    {
                                        perms.has('calculation.add') ?
                                            <div className='selectedComp__calc-save-btn-container'>
                                                {
                                                    isSaveLoader ?
                                                        <div style={{ position: 'absolute', left: '50%', bottom: '8%' }} className='loader'></div>
                                                        :
                                                        <button className='nav__button btn-primary selectedComp__calc-save-btn'
                                                                onClick={() => {
                                                                    handleSaveButton();
                                                                }}>
                                                            Сохранить расчёт
                                                        </button>
                                                }
                                            </div>
                                            :
                                            <span></span>
                                    }
                                    <div id='baseCalc-footer' style={{display: "flex", flexDirection: 'column'}}></div>
                                </div>
                            </>
                        ) : (
                            <p className='selectedComp__calc-no-table'>
                                У получателя платежа этого предприятия ещё не создана таблица расчёта — обратитесь к администратору.
                            </p>
                        )}
                    </div>
                </div>
                <div className="selectedComp_reports-container">
                    <CalculationsContainer
                        setIsActive={ setIsPopupActive }
                        setHeaderName={ setHeaderNamePopup }
                        setBodyDivElement={ setBodyDivElementPopup }
                    />
                    <HistoryContainer historyType={'companyHistory'} containerName={'selectedComp'}/>
                </div>
                <div className="selectedComp_ttn-container">
                    <TtnContainer
                        compData={ compData }
                        setIsActive={ setIsPopupActive }
                        setHeaderName={ setHeaderNamePopup }
                        setBodyDivElement={ setBodyDivElementPopup }
                    />
                </div>
            </div>
        </div>
    );
});

export default SelectedCompany;